import { API_ENDPOINTS } from "config/config";
import { buildTableDateFilterParams } from "utils/dateRangeParams";

export const buildExpenseFilterParams = ({ search, filters }) => {
  const params = {};

  if (search) params.search = search;
  if (filters?.category) params.category = filters.category;
  if (filters?.subcategory) params.subcategory = filters.subcategory;
  Object.assign(params, buildTableDateFilterParams(filters));

  return params;
};

export const fetchExpenseSummary = async (api, { search, filters }) => {
  const response = await api.get(API_ENDPOINTS.GET_EXPENSE_SUMMARY, {
    params: buildExpenseFilterParams({ search, filters }),
  });
  return response.data.data;
};

export const fetchExpenses = async (api, { search, filters, page, limit } = {}) => {
  const params = buildExpenseFilterParams({ search, filters });
  if (page) params.page = page;
  if (limit) params.limit = limit;

  const response = await api.get(API_ENDPOINTS.GET_EXPENSE, { params });
  return response.data.data;
};
